import React from 'react';

import DropDown from '../DropDown';

export default function Adress(props) {
    return <DropDown {...props} />;
}
